import withAuthGuard from "@/HOC/withAuthGuard";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated")({
  component: withAuthGuard(AuthenticatedRootComponent)
});

function AuthenticatedRootComponent() {
  return <Outlet />;
}
